import Loading from './Loading'
export default Loading


// WEBPACK FOOTER //
// ./src/pages/Loading/index.js